import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function ModifyComment({ OrderID, onClose, getOrders, onCommentID }) {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        title: onCommentID.title,
        comment: onCommentID.comment,
        id: onCommentID.ordt_ID,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/Orders/tracking/update`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                onClose();
                getOrders();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'An error occurred, please try again.',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    

    return (
        <div className="modal fade bs-example-modal-xl show azoomOutDown" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-modal="true" style={{ display: "block", backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myExtraLargeModalLabel">Add Comment</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="title" className="form-label">Situation</label>
                                        <select
                                            className="form-select"
                                            id="title"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select a situation...</option>
                                            <option value="Delay in Order">Delay in Order</option>
                                            <option value="Request for Design Modification">Request for Design Modification</option>
                                            <option value="Inquiry About Material">Inquiry About Material</option>
                                            <option value="Issue with Previous Order">Issue with Previous Order</option>
                                            <option value="Urgent Request">Urgent Request</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter your comment here"
                                            id="comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                
                                <div className="col-lg-12">
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Loading...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModifyComment;
